import React from 'react';
import Icon from './Icon';

const Modal = ({ children, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50 flex justify-center items-center p-4">
        <div className="bg-white rounded-xl shadow-2xl relative max-w-lg w-full">
            <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-[#7B34BB]">
                <Icon path="M6 18L18 6M6 6l12 12" className="w-6 h-6" />
            </button>
            {children}
        </div>
    </div>
);

export default Modal;

